import { get } from "lodash";
const styles = (theme) => ({
  uploadImageContainer: {
    backgroundColor: '#828282',
    width: 75,
    height: 75,
    borderRadius: '50%',
    textAlign: 'center',
    cursor: "pointer",
  },
  iconsContainer: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "1.8rem",
    paddingTop: 10,
  },
  logoIcon: {
    width: 16,
    marginTop: 3,
  },
  imagePreviewContainer: {
    width: 80,
    height: 80,
    border: "1px solid #D3D3D3",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imagePreview: {
    width: 60,
    height: 60,
    cursor: "pointer",
    objectFit: 'contain',
    objectPosition: 'center',
  },
  uploadPreviewContainer: {
    position: "relative",
  },
  cancelIcon: {
    position: "absolute",
    top: -10,
    right: -15,
    cursor: "pointer",
    color: get(theme, 'color.primaryButtonBackground'),
  },
  uploadButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    position: "relative",
  },
  name: {
    fontSize: '12px',
    color: get(theme, 'color.white'),
    width: "50%",
    marginLeft: 18,
    lineHeight: 1.2,
    marginTop: 3,
  },
  uploadFileButton: {
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  buttonImagePreview: {
    marginLeft: "2rem",
    width: "auto",
  },
  buttonImage: {
    marginLeft: "2rem",
    width: 50,
    height: 40,
  },
  hideInput: {
    display: 'none',
  },
  errorMessage: {
    color: get(theme, 'color.error'),
    position: "absolute",
    bottom: "-1.2rem",
    width: 400,
  },
})

export default styles;